export function useIsRetina() {
  return window.devicePixelRatio && window.devicePixelRatio >= 2;
}
